// 学科分类类型
export const subjectType = {
  1: '理学类',
  2: '工学类',
  3: '农学类',
  4: '医学类',
  5: '文科类（含哲学、经济学、法学、教育学、文学、历史学、管理学、艺术学等）',
  6: '交叉类',
  7: '其他',
}

// 建设范围
export const constructionScopeType = {
  1:'全国性',
  2:'区域性',
  3:'校内',
  4:'其他',
}
// 建设范围
export const levelType = {
  1:'国家级',
  2:'省级',
  3:'校级',
  4:'其他',
}
// 建设主体类型
export const mainTypes = {
  1:'课程（群）教学类',
  2:'专业建设类',
  3:'教学研究改革专题类',
  4:'其他',
}

// 教研室所有身份信息列表
export const allIdentitiesList = {
  0: '不是教研室成员',
  1: '管理员',
  2: '管理者',
  3: '引用者',
  4: '查看者'
}
// 可修改身份信息
export const TeachingResearchMemberRoleList = {
  2: {
    value: '2',
    label: '管理者',
    desc: '可以编辑、引用、浏览和分享'
  },
  3: {
    value: '3',
    label: '引用者',
    desc: '可以引用、浏览和分享'
  },
  4: {
    value: '4',
    label: '查看者',
    desc: '可以浏览和分享'
  },
}
// 职称
export const memberTitle = {
  1: '教授',
  2: '副教授',
  3: '讲师',
  4: '助教',
  5: '其他',
}

export const resourceTabsList = [
  {
    value: '0',
    label: '全部标签',
  }, {
    value: '3',
    label: '教学视频',
  }, {
    value: '2',
    label: '教学设计',
  }, {
    value: '4',
    label: '教学案例',
  }, {
    value: '5',
    label: '教学大纲',
  }
]

// 职称
export const activityType = {
  0: '全部',
  1: '话题讨论',
  2: '会议直播',
  3: '文章',
  4: '视频',
}


export enum SourceTypeEnum {
  DISCUSS_MEETING       = 1,  // 研讨会议
  DISCUSS_SUBJECT = 2, //讨论话题
  DISCUSS_ARTICLE = 22, //讨论文章
  DISCUSS_VIDEO = 23, //活动--视频
  NO_OFFICE_INFORMATION = 3, //资料
  INTERACTIVE_COURSEWARE = 5, //互动课件
  PAPER = 6, //试卷
  HOMEWORK = 7, //作业
  TOPIC = 8, //话题

  TEMPLATE_COURSE = 9, //样板课程
  TEMPLATE_COURSE_INTERACT_COURSEWARE = 10, //样板课程 - 教学活动 - 互动课件
  TEMPLATE_COURSE_INFORMATION = 11, //样板课程 - 教学活动 - 资料
  TEMPLATE_COURSE_MOOC_INFORMATION = 12, //样板课程 - 教学活动 - 慕课资料
  TEMPLATE_COURSE_TEST = 13, //样板课程 - 教学活动 - 测试
  TEMPLATE_COURSE_ANSWER = 14, //样板课程 - 教学活动 - 互动答题
  TEMPLATE_COURSE_HOMEWORK = 15, //样板课程 - 教学活动 - 作业
  TEMPLATE_COURSE_ANNOUNCEMENT = 16, //样板课程 - 教学活动 - 公告
  TEMPLATE_COURSE_TOPIC = 17, //样板课程 - 教学活动 - 话题

  ANNOUNCEMENT  = 18, //公告
  INTERACTIVE  = 19, //互动试卷
  LINK  = 20, //外链
}

//行为类型种类
export enum ActionLogTypeEnum {
  ENJOY = 1,//点赞
  COMMENT_COUNT = 2, //评论数 
  VISIT_COUNT = 3, //浏览数 
  DOWN_LOAD_COUNT = 4, //下载数 
  CITE_COUNT = 5, //引用数 
  TAKE_IN_COUNT = 6, //参与数
}

export enum VrtResourceTypeEnum{
  HOMEWORK = 0,//作业
  COURSEWARE = 1,//资料
  INTERACT_COURSEWARE = 2,//互动课件
  TESTPAPER = 3,//测试试卷
  TOPIC = 4,//话题
  WEBLINK = 5,//外链
  INTERACT_TESTPAPER = 6,//互动试卷
  MOOC_WEBLINK = 10,//慕课
  MOOC_RESOURCE = 10,//慕课资源，有视频的
}

export enum VrtRoleEnum{
  NONE = 0,//不是教研室成员
  SUPER = 1,//超级管理
  MANAGE = 2,//管理者
  CITE = 3,//引用者
  VISIT = 4,//查看者
}

/** 人次参与讨论：评论数 + 发帖作者 1 次（仅话题讨论展示用） */
export function getDiscussParticipateCount(commentTotal?: number | string): number {
  return (Number(commentTotal) || 0) + 1
}